module.exports = __webpack_public_path__ + "img/hero.f267b31f.png";